import ApexCharts from "apexcharts";
import './lightbox';

const charts = document.querySelectorAll('.chart');

if (charts.length) {
    [...charts].forEach(async el => {
        const data = el.getAttribute('data-json');
        const values = JSON.parse(data);

        let options = {
            chart: {
                type: 'area',
                height: 350,
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false
                },
                defaultLocale: 'en'
            },
            series: [{
                name: values.name,
                data: values.data
            }],
            xaxis: {
                type: 'date'
            },
            stroke: {
                curve: 'smooth',
                colors: [values.marker.toString()],
            },
            fill: {
                colors: [values.marker.toString()],
            },
            markers: {
                size: 4,
                colors: [values.marker.toString()],
            },
            yaxis: {
                opposite: true
            },
            legend: {
                horizontalAlign: 'left'
            },
            title: {
                text: values.name
            }
        };

        let chart = new ApexCharts(el, options);
        await chart.render();
    });
}
